export default class FiveCardHandLeaf {
  constructor(argsObj) {
    this.id = argsObj.id;
    this.text = argsObj.text;
    this.fullText = argsObj.fullText;
    this.inlineText = argsObj.inlineText;
    this.count = 0;
    this._probability = null;
    this._weight = 0;
    this.included = true;
    this.matchingSpecificHands = [];
    this.percentageOfSpecificHandsThatAreSelected = 0;
    this.isAHit = argsObj.isAHit;
  };

  get visible() {
    if (!this.included) {
      return false;
    }

    // would be null if a simulation hadn't been run yet
    if (this._probability === 0) {
      return false;
    }

    return true;
  };
  get checked() {
    if (!this.visible) {
      throw new Error('Trying to get the checked value of a five card hand that isn\'t visible.');
    }

    return this.weight > 0;
  };
  get probability() {
    if (this._probability === null) {
      return 0;
    }

    else if (typeof this._probability !== 'number') {
      throw new Error('Invalid value of _probability.');
    }

    return this._probability.roundToTwoDecimalPlaces();
  };
  get weight() {
    if (!this.visible) {
      throw new Error('Trying to get the weight of a five card hand that isn\'t visible.');
    }

    return this._weight;
  };
  get hasWeight() {
    return (
      this.visible &&
      this.weight < 100 &&
      this.weight > 0
    );
  };
  get hasExplicitWeight() { // for FiveCardHandParents, this differs from hasWeight
    return (
      this.visible &&
      this.weight < 100 &&
      this.weight > 0
    );
  };

  set checked(newCheckedValue) {
    if (!this.visible) {
      throw new Error('Trying to set the checked value of a five card hand that isn\'t visible.');
    }

    if (newCheckedValue === true) {
      this.weight = 100;
    } else {
      this.weight = 0;
    }

  };
  set weight(newWeight) {
    if (!this.visible) {
      throw new Error('Trying to set the weight of a five card hand that isn\'t visible.');
    }

    if (
      (typeof newWeight !== 'number') ||
      (newWeight < 0) ||
      (newWeight > 100) ||
      (newWeight % 5 !== 0)
    ) {
      throw new Error('Invalid value of newWeight');
    }

    this._weight = newWeight;
  };

  getDefaultCheckedValue(fiveCardHandsThatAreCheckedByDefault, playerStateName) {
    if (this.madeHandDrawOrCombo === 'made hand') {
      return fiveCardHandsThatAreCheckedByDefault.madeHands.includes(this.id);
    }

    else if (this.madeHandDrawOrCombo === 'draw' && playerStateName !== 'afterRiver') {
      return fiveCardHandsThatAreCheckedByDefault.draws.includes(this.id);
    }

    else if (this.madeHandDrawOrCombo === 'combo' && playerStateName !== 'afterRiver') {
      return fiveCardHandsThatAreCheckedByDefault.combos.includes(this.id);
    }

    else {
      return false;
    }
  };
  setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
    this.matchingSpecificHands = [];
    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (specificHand.matchesFiveCardHand(this, presetCommunityCardsArray, shortDeck)) {
        this.matchingSpecificHands.push(specificHand.string);
      }
    }, this);
  };
  setProbabilityAccordingToMatchingSpecificHands(generalHands) {
    let numberOfPossibleSpecificHands = generalHands.numberOfPossibleSpecificHands;
    let numberOfMatchingSpecificHands = 0;
    let currSpecificHand;

    this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
      currSpecificHand =  generalHands.find(matchingSpecificHandString);
      numberOfMatchingSpecificHands += (currSpecificHand.maxPossibleWeight) / 100;
    });

    this._probability = (numberOfMatchingSpecificHands / numberOfPossibleSpecificHands) * 100;
  };
  getNumCombos(numberOfPossibleSpecificHands) {
    return ((this.probability / 100) * numberOfPossibleSpecificHands).roundToOneDecimalPlace();
  };
  setPercentageOfSpecificHandsThatAreSelected(generalHands) {
    let checked = this._weight > 0; // small hack to get around issue where you can't check the checked property before it's visible

    if (this.matchingSpecificHands.length === 0) {
      if (checked) {
        return 100;
      } else {
        return 0;
      }
    }

    this.percentageOfSpecificHandsThatAreSelected = (
      this._getWeightedNumSpecificHandsThatAreSelected(generalHands) /
      this._getWeightedNumSpecificHandsThatArePossible(generalHands)
    ) * 100;
  };
  _getWeightedNumSpecificHandsThatAreSelected(generalHands) {
    let currSpecificHand;
    let weightedNumSpecificHandsThatAreSelected = 0;

    this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
      currSpecificHand = generalHands.find(matchingSpecificHandString);

      if (currSpecificHand.possible) {
        weightedNumSpecificHandsThatAreSelected += currSpecificHand.weight;
      }
    });

    return weightedNumSpecificHandsThatAreSelected;
  };
  _getWeightedNumSpecificHandsThatArePossible(generalHands) {
    let currSpecificHand;
    let weightedNumSpecificHandsThatAreSelected = 0;

    this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
      currSpecificHand = generalHands.find(matchingSpecificHandString);

      if (currSpecificHand.possible) {
        weightedNumSpecificHandsThatAreSelected += currSpecificHand.maxPossibleWeight;
      }
    });

    return weightedNumSpecificHandsThatAreSelected;
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/five-card-hand-leaf/FiveCardHandLeaf.js